import {
  PLATFORM_LIST,
  PLATFORM_LIST_TOLGEE_NAMES,
  PLATFORM_LIST_WITH_ALL
} from '../../../../config/constants';

export const options = [
  // Order to loop through keys

  {
    name: 'tone',
    options: [
      { key: 0, label: 'lomavisCreator.aiAssistant.tone.null' },
      { key: 1, label: 'lomavisCreator.aiAssistant.tone.affectionate' },
      { key: 2, label: 'lomavisCreator.aiAssistant.tone.creative' },
      { key: 3, label: 'lomavisCreator.aiAssistant.tone.descriptive' },
      { key: 4, label: 'lomavisCreator.aiAssistant.tone.dramatic' },
      { key: 5, label: 'lomavisCreator.aiAssistant.tone.educational' },
      { key: 6, label: 'lomavisCreator.aiAssistant.tone.emphatic' },
      { key: 7, label: 'lomavisCreator.aiAssistant.tone.formal' },
      { key: 8, label: 'lomavisCreator.aiAssistant.tone.humorous' },
      { key: 9, label: 'lomavisCreator.aiAssistant.tone.informal' },
      { key: 10, label: 'lomavisCreator.aiAssistant.tone.ironic' },
      { key: 11, label: 'lomavisCreator.aiAssistant.tone.melancholic' },
      { key: 12, label: 'lomavisCreator.aiAssistant.tone.positive' },
      { key: 13, label: 'lomavisCreator.aiAssistant.tone.scientific' }
    ]
  },

  {
    name: 'language',
    options: [
      { key: 'en-us', label: 'lomavisCreator.aiAssistant.language.english' },
      { key: 'de', label: 'lomavisCreator.aiAssistant.language.german' }
    ]
  },

  {
    name: 'platform',
    options: [
      { key: 0, label: 'lomavisCreator.platforms.null' },
      ...PLATFORM_LIST.map((key) => ({
        key,
        label: PLATFORM_LIST_TOLGEE_NAMES[key]
      }))
    ]
  }
];
export const fields = [
  {
    id: 'own_identity',
    label: 'lomavisCreator.aiAssistant.labels.ownIdentity',
    type: 'textarea',
    rows: 3,
    placeholder: '', // 'lomavisCreator.aiAssistant.placeholders.ownIdentity'
    maxLength: 500,
    helpText: 'lomavisCreator.aiAssistant.helpText.ownIdentity'
  },
  {
    id: 'target_audience',
    label: 'lomavisCreator.aiAssistant.labels.target_audience',
    type: 'textarea',
    rows: 3,
    placeholder: '', // 'lomavisCreator.aiAssistant.placeholders.target_audience'
    maxLength: 500,
    helpText: 'lomavisCreator.aiAssistant.helpText.target_audience'
  },
  {
    id: 'post_example',
    label: 'lomavisCreator.aiAssistant.labels.post_example',
    type: 'textarea',
    rows: 3,
    placeholder: '', // 'lomavisCreator.aiAssistant.placeholders.post_example'
    maxLength: 500,
    helpText: 'lomavisCreator.aiAssistant.helpText.post_example'
  },
  {
    id: 'homepage',
    label: 'lomavisCreator.aiAssistant.labels.homepage',
    type: 'input',
    inputType: 'url',
    placeholder: '', // 'lomavisCreator.aiAssistant.placeholders.homepage'
    maxLength: 500,
    helpText: 'lomavisCreator.aiAssistant.helpText.homepage'
  },
  {
    id: 'additional_instructions',
    label: 'lomavisCreator.aiAssistant.labels.additional_instructions',
    type: 'textarea',
    rows: 3,
    placeholder: '', // 'lomavisCreator.aiAssistant.placeholders.additional_instructions'
    maxLength: 500,
    helpText: 'lomavisCreator.aiAssistant.helpText.additional_instructions'
  }
];

export const QUICK_ACTIONS = [
  {
    id: 1,
    name: 'lomavisCreator.aiAssistant.shortenText',
    icon: 'fa-solid fa-minus',
    action: 'shortenText',
    checkEnabledPlatforms: false
  },
  {
    id: 2,
    name: 'lomavisCreator.aiAssistant.lengthenText',
    icon: 'fa-solid fa-align-left',
    action: 'lengthenText',
    checkEnabledPlatforms: false
  },
  {
    id: 3,
    name: 'lomavisCreator.aiAssistant.addCallToAction',
    icon: 'fa-solid fa-bullhorn',
    action: 'addCallToAction',
    checkEnabledPlatforms: false
  },
  {
    id: 4,
    name: 'lomavisCreator.aiAssistant.addHashtags',
    icon: 'fa-solid fa-hashtag',
    action: 'addHashtags',
    checkEnabledPlatforms: false
  },
  {
    id: 5,
    name: 'lomavisCreator.aiAssistant.addEmojis',
    icon: 'fa-solid fa-smile',
    action: 'addEmojis',
    checkEnabledPlatforms: false
  },
  {
    id: 6,
    name: 'lomavisCreator.aiAssistant.changeTone',
    icon: 'fa-solid fa-adjust',
    action: 'changeTone',
    options: options.find((option) => option.name === 'tone')?.options,
    playloadField: 'tone',
    checkEnabledPlatforms: false
  },
  {
    id: 7,
    name: 'lomavisCreator.aiAssistant.restructureText',
    icon: 'fa-solid fa-sync',
    action: 'restructureText',
    checkEnabledPlatforms: false
  },
  {
    id: 8,
    name: 'lomavisCreator.aiAssistant.optimizeForPlatform',
    icon: 'fa-solid fa-share-alt',
    action: 'optimizePlatform',
    options: options.find((option) => option.name === 'platform')?.options,
    playloadField: 'platform',
    checkEnabledPlatforms: true
  }
];

export const MAIN_QUICK_ACTIONS = [
  {
    id: -1,
    name: 'lomavisCreator.aiAssistant.generateText',
    icon: 'fa-duotone fa-image',
    action: 'generateText',
    checkEnabledPlatforms: false
  },
  {
    id: 9,
    name: 'lomavisCreator.aiAssistant.analyzeImage',
    icon: 'fa-duotone fa-image',
    action: 'analyzeImage',
    checkEnabledPlatforms: false
  },
  {
    id: 10,
    name: 'lomavisCreator.aiAssistant.createPostUrl',
    icon: 'fa-duotone fa-link',
    action: 'createPostUrl',
    checkEnabledPlatforms: false
  },
  {
    id: 11,
    name: 'lomavisCreator.aiAssistant.rewriteText',
    icon: 'fa-duotone fa-sync',
    action: 'rewriteText',
    checkEnabledPlatforms: false
  }
];
